//#region recipes/buttons/callbar_button/callbar_button_constants.js
var e = [
	"sm",
	"md",
	"lg",
	"xl"
], t = { CALLBAR_BUTTON_VALID_WIDTH_SIZE: e };
//#endregion
export { e as CALLBAR_BUTTON_VALID_WIDTH_SIZE, t as default };

//# sourceMappingURL=callbar-button-constants.js.map